import { Form, FormikProvider, useFormik } from 'formik';
import { CircularProgress, Grid, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import * as Yup from 'yup';
import useIsMountedRef from '../../hooks/useIsMountedRef';
import { useTranslation } from 'react-i18next';
import { ProductType } from '../../@types/model/productType';

export interface ProductTypeFormProps {
  productType: ProductType;
  edit: boolean;
  submitHandler: (group: ProductType) => void;
  loading: boolean;
}

type createOrUpdateProductTypeInitialValues = {
  guid: string;
  name: string;
  created_by: string;
  state: string;
  workspace: string;
};

const ProductTypeForm = (props: ProductTypeFormProps) => {
  const isMountedRef = useIsMountedRef();
  const { t } = useTranslation();

  const createOrUpdateProductTypeShchema = Yup.object().shape({
    name: Yup.string().required(t('El nombre es necesario'))
  });

  const CreateOrUpdateProductType = useFormik<createOrUpdateProductTypeInitialValues>({
    initialValues: {
      guid: props.productType.guid,
      name: props.productType.name,
      created_by: props.productType.created_by,
      state: props.productType.state,
      workspace: props.productType.workspace
    },
    validationSchema: createOrUpdateProductTypeShchema,
    onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
      try {
        //await chagePassword(values.email, values.password, values.newPassword);
        props.submitHandler({
          guid: props.productType.guid,
          name: values.name,
          created_by: props.productType.created_by,
          state: props.productType.state,
          workspace: props.productType.workspace
        } as ProductType);
        if (isMountedRef.current) {
          setSubmitting(false);
        }
      } catch (error: any) {
        resetForm();
        if (isMountedRef.current) {
          setSubmitting(false);
        }
      }
    }
  });
  return (
    <FormikProvider value={CreateOrUpdateProductType}>
      <Form autoComplete="off" noValidate onSubmit={CreateOrUpdateProductType.handleSubmit}>
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              autoComplete={t('name')}
              type="string"
              label={t('name')}
              {...CreateOrUpdateProductType.getFieldProps('name')}
              error={Boolean(
                CreateOrUpdateProductType.touched.name && CreateOrUpdateProductType.errors.name
              )}
              helperText={
                CreateOrUpdateProductType.touched.name && CreateOrUpdateProductType.errors.name
              }
            />
          </Grid>
        </Grid>
        <LoadingButton
          disabled={props.loading}
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={CreateOrUpdateProductType.isSubmitting}
          sx={{ my: 2 }}
        >
          {props.loading ? <CircularProgress size={26} /> : props.edit ? t('update') : t('add')}
        </LoadingButton>
      </Form>
    </FormikProvider>
  );
};

export default ProductTypeForm;
